import "./bloc-reviews-slider.scss";

import Swiper from "swiper";
import { Navigation } from "swiper/modules";

const reviewsSliderInit = () => {
  const blocSlider = document.querySelector(".blocReviewsSlider");

  if (!blocSlider) return;

  const sliders = document.querySelectorAll(".blocReviewsSlider__swiper");

  if (!sliders.length) return;

  sliders.forEach((sliderEl) => {
    const prevBtn = blocSlider.querySelector(".swiper-button-prev");
    const nextBtn = blocSlider.querySelector(".swiper-button-next");

    new Swiper(sliderEl, {
      modules: [Navigation],
      slidesPerView: 1.2,
      spaceBetween: 20,
      navigation: {
        prevEl: prevBtn,
        nextEl: nextBtn,
      },
      breakpoints: {
        500: {
          slidesPerView: 1.5,
        },
        768: {
          slidesPerView: 2.5,
          spaceBetween: 25,
        },
        991: {
          slidesPerView: 3,
        },
      },
    });
  });
};

document.addEventListener("DOMContentLoaded", () => {
  reviewsSliderInit();
});
